var _path, _path2, _path3, _rect, _g, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonePreviewBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 293,
    viewBox: "0 0 252 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.242676 34.7599C0.242676 29.3891 4.59658 25.0352 9.96739 25.0352H99.3423C104.713 25.0352 109.067 29.3891 109.067 34.7599V119.262C109.067 124.633 104.713 128.987 99.3423 128.987H9.96738C4.59657 128.987 0.242676 124.633 0.242676 119.262V34.7599Z",
    fill: "#017BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.813 34.7599C118.813 29.3891 123.167 25.0352 128.538 25.0352H217.913C223.284 25.0352 227.638 29.3891 227.638 34.7599V119.262C227.638 124.633 223.284 128.987 217.913 128.987H128.538C123.167 128.987 118.813 124.633 118.813 119.262V34.7599Z",
    fill: "#F8F9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.382 34.7599C237.382 29.3891 241.736 25.0352 247.107 25.0352H252V128.987H247.107C241.736 128.987 237.382 124.633 237.382 119.262V34.7599Z",
    fill: "#F8F9FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1845_6638",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 240,
    y: 36,
    width: 12,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 240.623,
    y: 36.4014,
    width: 11.3455,
    height: 22.691,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1845_6638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.704 44.5488C263.215 44.5488 262.568 44.538 261.761 44.538C259.795 44.538 258.178 42.9105 258.178 40.9257V37.4433C258.178 37.1694 257.959 36.9463 257.688 36.9463H251.961C249.288 36.9463 247.127 39.1401 247.127 41.8288V53.4963C247.127 56.317 249.391 58.6029 252.184 58.6029H260.713C263.376 58.6029 265.535 56.4231 265.535 53.7323V45.0361C265.535 44.7611 265.318 44.5391 265.045 44.5402C264.588 44.5434 264.039 44.5488 263.704 44.5488",
    fill: "#017BFF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.656 42.8396C151.202 42.5537 150.644 42.5285 150.169 42.7703L148.564 43.5805C147.971 43.8795 147.603 44.4841 147.603 45.1569V51.4736C147.603 52.1464 147.971 52.7499 148.564 53.0511L150.168 53.8602C150.386 53.9724 150.618 54.0262 150.851 54.0262C151.131 54.0262 151.408 53.9471 151.656 53.7921C152.11 53.5074 152.38 53.0138 152.38 52.4729V44.1598C152.38 43.619 152.11 43.1254 151.656 42.8396",
    fill: "#017BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.449 56.4368H135.177C132.555 56.4368 130.724 54.6284 130.724 52.0395V44.5916C130.724 42.0016 132.555 40.1943 135.177 40.1943H141.449C144.072 40.1943 145.903 42.0016 145.903 44.5916V52.0395C145.903 54.6284 144.072 56.4368 141.449 56.4368",
    fill: "#017BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0348 36.9453H17.9284C14.242 36.9453 12.1533 39.034 12.1533 42.7204V52.8268C12.1533 56.5036 14.2324 58.6019 17.9284 58.6019H28.0348C31.7213 58.6019 33.8099 56.5036 33.8099 52.8268V42.7204C33.8099 39.034 31.7213 36.9453 28.0348 36.9453Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5772 48.5407H23.7933V51.3005C23.7933 51.7448 23.4299 52.105 22.9817 52.105C22.5335 52.105 22.1701 51.7448 22.1701 51.3005V48.5407H19.3862C18.9681 48.4978 18.6504 48.1485 18.6504 47.7318C18.6504 47.3151 18.9681 46.9658 19.3862 46.9229H22.1614V44.1718C22.2047 43.7574 22.557 43.4424 22.9773 43.4424C23.3977 43.4424 23.75 43.7574 23.7933 44.1718V46.9229H26.5772C26.9953 46.9658 27.313 47.3151 27.313 47.7318C27.313 48.1485 26.9953 48.4978 26.5772 48.5407V48.5407Z",
    fill: "#017BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 9,
    rx: 4,
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 147,
    width: 148,
    height: 9,
    rx: 4,
    fill: "#F0F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: 181,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.824,
    y: 181,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: 243.588,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 126.824,
    y: 243.588,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5884,
    y: 181,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 189.412,
    y: 181,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5884,
    y: 243.588,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 189.412,
    y: 243.588,
    width: 49.4118,
    height: 49.4118,
    rx: 6.57421,
    fill: "#F8F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePreviewBody);
export default __webpack_public_path__ + "static/media/phone-preview-body.f876f4d11fbf39dd795564e829d37748.svg";
export { ForwardRef as ReactComponent };